import React, { FC } from "react";
import LinearProgressBar, { LinearProgressProps } from "@material-ui/core/LinearProgress";
import { makeStyles, Theme } from "@material-ui/core";
import classnames from "classnames";
import theme from "styles/theme";
import { DATATEST } from "../../../constants/integration";

export interface ILinearProgressClasses {
    root?: string;
    label?: string;
    progress?: string;
    progressWrapper?: string;
    progressSecondaryColor?: string;
    percents?: string;
    percentsWrapper?: string;
}

interface IProps extends LinearProgressProps {
    value: number;
    label?: string;
    classes?: ILinearProgressClasses;
}

export const LinearProgress: FC<IProps> = (props) => {
    const { value, classes: propsClasses, label, ...rest } = props;

    const classes = useStyles({});
    return (
        <div className={classnames(classes.root, propsClasses?.root)}>
            {label && (
                <span
                    data-test={DATATEST.LINEAR_PROGRESS.LABEL}
                    className={classnames(classes.label, propsClasses?.label)}
                >
                    {label}
                </span>
            )}
            <div className={classnames(classes.progressWrapper, propsClasses?.progressWrapper)}>
                <div className={classnames(classes.progress, propsClasses?.progress)}>
                    <LinearProgressBar
                        variant="determinate"
                        classes={{
                            barColorPrimary: classnames(
                                classes.progressSecondaryColor,
                                propsClasses?.progressSecondaryColor
                            ),
                        }}
                        value={value}
                        {...rest}
                    />
                </div>
                <div className={classnames(classes.percentsWrapper, propsClasses?.percentsWrapper)}>
                    <span className={classnames(classes.percents, propsClasses?.percents)}>{`${Math.round(
                        value
                    )}%`}</span>
                </div>
            </div>
        </div>
    );
};

const useStyles = makeStyles<Theme, {}>({
    root: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    label: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
    },
    progressWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
    },
    progress: {
        width: "100%",
        flexGrow: 1,
        hegiht: 6,
    },
    progressSecondaryColor: {
        backgroundColor: theme.palette.accent1Color,
    },
    percentsWrapper: {
        minWidth: 35,
        marginLeft: 10,
        display: "flex",
        alignItems: "center",
    },
    percents: {
        fontSize: 12,
    },
});
